import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
} from "@angular/core";
import { Router } from "@angular/router";
import { PLAuctionEntry } from "src/app/Shared/Model/pl-auction-entry";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AuctionEntryServiceService } from "src/app/Shared/Services/auction-entry-service.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { DateCompareService } from "src/app/Shared/Services/date-compare.service";
import { TranslationService } from "src/app/Shared/Model/TranslationService";
import { Observable } from 'rxjs';            // Import Observable
import { map } from 'rxjs/operators';
declare var $: any;

@Component({
  selector: "app-auction-updation",
  templateUrl: "./auction-updation.component.html",
  styleUrls: ["./auction-updation.component.css"],
})
export class AuctionUpdationComponent implements OnInit {
  FrmAuctionUpdation: FormGroup;
  loginlist: any = [];
  Verification: FormGroup;
  AuctionSearchFillList: any = [];
  AuctionSearchFillPDFList: any[];
  AuctionId: number;
  DownloadAuctionList: any = [];
  DownloadFilterAuction: any = [];
  AuctionSearchFillPDFListNew: any = [];
  vt: string;
  id: Number;
  Image: string;
  btnAddUpdate: string;
  MaxDBSrNo: number;

  model: PLAuctionEntry;
  minDate: Date;
  maxDate: Date;
  checkAppDate: boolean = false;
  uploadfilename: string = "";
  AutoIdImage: string;
  RegistrationDateinvalidMsg: string;
  dateValidationMsg: string;

  ddlDepartmentList: any = [];
  ddlAuthorityList: any = [];
  ddlAuctionTypeList: any = [];
  ddlBiddingTypeList: any = [];
  ddlOfficerList: any = [];
  ddlZoneList: any = [];
  pdfSrc: any;
  title = "Check";
  fileData: File = null;
  formData: string = null;
  filename: string = null;
  base64url: any;
  AuctionShowArraysLive: any = [];
  DownloadAuctionTrue: boolean = true;
  DownloadAuctionFalse: boolean = false;
  edited: Boolean;
  editedSearch: Boolean;
  myBool: Boolean;

  ParticipationDocsList: any = [];
  CheckedDocsList: any = [];
  VerificationList: any = [];
  verifyselectedDA: any = [];
  verifyselectedRO: any = [];
  verifyselectedDC: any = [];

  dataSourceDownloadAuction = new MatTableDataSource(this.DownloadAuctionList);
  dataSourceDocuments = new MatTableDataSource(
    this.AuctionSearchFillPDFListNew
  );
  // ImgLoading: boolean = false;
  displayedColumnsLive = [
    "SrNo",
    "AuctionNo",
    "AuctionTitle",
    "AuctionType",
    "AuctionStartDate",
    "AuctionEndDate",
    "Action",
  ];
  dataSourceLive = new MatTableDataSource<any>(this.AuctionShowArraysLive);

  displayedColumnsDownloadAuction: string[] = [
    "SrNo",
    "DocumentName",
    "Description",
    "Download",
    "Action",
  ]; ////'DocumentType',
  ListDA: any[];
  ListRO: any[];
  ListDC: any[];
  ChkExtChecked: boolean = false;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  YesCheck: boolean = false;
  NoCheck: boolean = true;
  constructor(
    private fb: FormBuilder,
    private MsgService: ToastrService,
    private router: Router,
    private AuctionEntryService: AuctionEntryServiceService,
    private CompareSrvc: DateCompareService
    ,private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.id = 0;
    this.btnAddUpdate = "Add";
    this.FillAllDDL();
    this.CreateAuctionUpdation();
    // this.editedSearch = true;
    //this.edited = false;
    this.GridAuctionLive();
    this.editedSearch = false;
    //this.OnZone_SelectIndex();

    this.FrmAuctionUpdation.controls["ddlVerifyDA"].disable();
    this.FrmAuctionUpdation.controls["ddlVerifyRO"].disable();
    this.FrmAuctionUpdation.controls["ddlVerifyDC"].disable();

    this.FrmAuctionUpdation.controls["txtAllext1"].disable();
    this.FrmAuctionUpdation.controls["txtAllext2"].disable();
    this.FrmAuctionUpdation.controls["txtAllext3"].disable();
    this.FrmAuctionUpdation.controls["txtAllext4"].disable();

    this.FrmAuctionUpdation.controls["txtAllext1"].setValue("");
    this.FrmAuctionUpdation.controls["txtAllext2"].setValue("");
    this.FrmAuctionUpdation.controls["txtAllext3"].setValue("");
    this.FrmAuctionUpdation.controls["txtAllext4"].setValue("");
  }

  // add By Mayank 07/02/2025 start
  TranslationAPI(translateValue: any): Observable<string> {        
    const txtBox = translateValue;  // Get the text to translate
    return this.translationService.translateText(txtBox).pipe(
      map(response => response[0].translations[0].text)  // Extract the translated text
    );
  }

  OnLanguageType_SelectIndexChange(){
    this.FrmAuctionUpdation.controls['txtAuctionTitle'].setValue('');
    this.FrmAuctionUpdation.controls['txtLocation'].setValue('');
    this.FrmAuctionUpdation.controls['txtDetails'].setValue('');    
  }
  
  OnTranslationService(event: any, TxtID: string): void {   
    if( this.FrmAuctionUpdation.controls["ddlLanguage"].value == 1)
  {
    this.TranslationAPI(event.target.value).subscribe(
      (translatedText) => {              
          this.FrmAuctionUpdation.controls[TxtID].setValue(translatedText);        
        console.log('Translated Text:', translatedText);
      },
      (error) => {
        console.error('Error translating text:', error);
      }
    );
  }
 }
//  End

  CreateAuctionUpdation() {
    this.FrmAuctionUpdation = this.fb.group({
      ddlDepartment: ["", Validators.required],
      txtAuctionNo: ["", [Validators.required, Validators.maxLength(20)]],
      txtAuctionPublishDate: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
        ],
      ],
      txtAuctionTitle: ["", [Validators.required, Validators.maxLength(100)]],
      txtLocation: ["", [Validators.required, Validators.maxLength(150)]],
      txtDetails: ["", [Validators.required, Validators.maxLength(200)]],
      ////txtDescription: ['', [Validators.required, Validators.maxLength(300)]],
      ddlAuthority: ["", Validators.required],
      ddlAuctionType: ["5", Validators.required],
      ddlBiddingType: ["", Validators.required],
      txtIncreaseDecreaseAmt: [
        "",
        [Validators.required, Validators.maxLength(15)],
      ],
      txtEstimatedAuctionAmt: [""],  //[Validators.required, Validators.maxLength(15)],
      txtAuctionFees: ["", [Validators.required, Validators.maxLength(15)]],
      txtRegistrationDateFrom: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtRegistrationDateTo: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtStartingPrice: ["", [Validators.required, Validators.maxLength(15)]],
      txtEMDSubmissionAmt: [
        "",
        [Validators.required, Validators.maxLength(15)],
      ],
      txtEMDSumissionDateFrom: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtEMDSubmissionStartTime: ["", Validators.required],
      txtEMDSubmissionEndTime: ["", Validators.required],
      txtEMDSubmissionDateTo: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtAuctionStartDate: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtAuctionStartTime: ["", Validators.required],
      txtAuctionEndDate: [
        "",
        [Validators.maxLength(10), Validators.minLength(10)],
      ],
      txtAuctionEndTime: ["", Validators.required],
      file: [""],
      ddlOfficer: ["", Validators.required],
      ddlZone: ["", Validators.required],
      txtFinalAuctionEndTime: ["", Validators.required],
      txtDocumentName: [""],
      ////txtDocumentType: [''],
      txtDocumentDescription: [""],
      Verification: [""],
      ShowWinner: ["0", Validators.required],
      AllowedExemption: ["0", Validators.required],
      //Verification: ['2', Validators.required],
      ddlVerifyDA: ["", Validators.required],
      ddlVerifyRO: ["", Validators.required],
      ddlVerifyDC: ["", Validators.required],
      txtLatitude: ["", Validators.required],
      txtLongitude: ["", Validators.required],
      chkLatLong: ["", Validators.required],
      txtAllext1: ["", Validators.required],
      txtAllext2: ["", Validators.required],
      txtAllext3: ["", Validators.required],
      txtAllext4: ["", Validators.required],
      chkAllowExnt: [false, Validators.required],
      txtRegistrationTimeFrom: ['', Validators.required],
      txtRegistrationTimeTo: ['', Validators.required],
      ddlLanguage: ["", Validators.required],
      // ChkParticipationDocs: ['', Validators.required],
    });
  }

  RadioChange(evt: number) {
    var target = evt; //evt.target.value;
    if (target == 1) {
      this.myBool = true;
      this.FrmAuctionUpdation.controls["ddlVerifyDA"].enable();
      this.FrmAuctionUpdation.controls["ddlVerifyRO"].enable();
      this.FrmAuctionUpdation.controls["ddlVerifyDC"].enable();
    } else {
      // this.OnZone_SelectIndex();
      this.myBool = false;
      this.FrmAuctionUpdation.controls["ddlVerifyDA"].disable();
      this.FrmAuctionUpdation.controls["ddlVerifyRO"].disable();
      this.FrmAuctionUpdation.controls["ddlVerifyDC"].disable();
    }
  }
  Clear() {
    this.FrmAuctionUpdation.reset();
    this.uploadfilename = "";
    //this.edited = false;
    $("#PannelView").css("display", "none");
    this.editedSearch = true;
    this.FrmAuctionUpdation.controls["txtAuctionNo"].enable();
    this.FrmAuctionUpdation.controls["ddlAuctionType"].enable();
    this.FrmAuctionUpdation.controls["ShowWinner"].setValue("0");
    this.FrmAuctionUpdation.controls["AllowedExemption"].setValue("0");
    this.ChkExtChecked = false;
  }

  OnDownloadAuction(AutoId: any, AuctionId: any, SrNo: Number) {
    this.DownloadFilterAuction = [];
    this.DownloadFilterAuction = this.AuctionSearchFillPDFList.filter(
      (m) => m.AutoId == AutoId && m.AuctionId == AuctionId && m.SrNo == SrNo
    );

    let DownLLink = this.DownloadFilterAuction[0]["VirtualPath"];

    const link = document.createElement("a");
    link.target = "_blank";
    link.href = DownLLink;
    link.setAttribute("visibility", "hidden"); //JMCEauctionAPI\Documents\AuctionPDF
    link.click();
  }
  OnAuctionUpdation() {
    try {
      let a = this.AuctionSearchFillList[0]["ParticipationVerifyInd"];
      if (a != 1 && a != 2) {
        this.MsgService.error("Please Select Participation verification...!!");
        return;
      }

      if (a == 2) {
        //this.ChkParticipationDocsLst = [];
        // this.ChkParticipationDocsLst.push({ 'DocId': null, 'DocName': null });
        this.CheckedDocsList.push({ DocId: null, DocName: null });
      } else {
        if (this.CheckedDocsList.length == 0) {
          this.MsgService.warning(
            "Please Check Atleast 1 Participation Docs Type...!!"
          );
          return;
        }
      }
      if (this.FrmAuctionUpdation.controls['txtRegistrationTimeFrom'].value == '' || this.FrmAuctionUpdation.controls['txtRegistrationTimeFrom'].value == null|| this.FrmAuctionUpdation.controls['txtRegistrationTimeFrom'].value == '00:00:00') {
        this.MsgService.warning("Please Entry Correct Registration Time From...!!");
        return;
      }
      if (this.FrmAuctionUpdation.controls['txtRegistrationTimeTo'].value == '' || this.FrmAuctionUpdation.controls['txtRegistrationTimeTo'].value == null|| this.FrmAuctionUpdation.controls['txtRegistrationTimeTo'].value == '00:00:00') {
        this.MsgService.warning("Please Entry Correct Registration Time To...!!");
        return;
      }
      // this.ImgLoading = true;
      this.model = new PLAuctionEntry();
      this.model.Ind = 5;
      if (this.myBool == true) {
        this.model.ParticipationVerificationInd = 1;
      } else {
        this.model.ParticipationVerificationInd = 2;
      }
      this.model.AuctionId = this.AuctionSearchFillList[0]["AuctionId"];
      // *************************************change 16012020 *****************************
      let ResponseDecrpt = sessionStorage.getItem("loginSession");
      this.loginlist = JSON.parse(window.atob(ResponseDecrpt));
      this.model.OrgCode = this.loginlist[0]["OrgCode"];
      this.model.CityCode = this.loginlist[0]["CityCode"];
      this.model.UserId = this.loginlist[0]["UserId"];

      if (this.myBool == true) {
        this.model.DAUserId =
          this.FrmAuctionUpdation.controls["ddlVerifyDA"].value;
        this.model.ROUserId =
          this.FrmAuctionUpdation.controls["ddlVerifyRO"].value;
        this.model.DCUserId =
          this.FrmAuctionUpdation.controls["ddlVerifyDC"].value;
      } else {
        this.model.DAUserId = 0;
        this.model.ROUserId = 0;
        this.model.DCUserId = 0;
      }
      // ****************end*************************************************

      this.model.DeptCode =
        this.FrmAuctionUpdation.controls["ddlDepartment"].value;
      this.model.OfficerCode =
        this.FrmAuctionUpdation.controls["ddlOfficer"].value;
      this.model.ZoneCode = this.FrmAuctionUpdation.controls["ddlZone"].value;
      this.model.AuctionNo =
        this.FrmAuctionUpdation.controls["txtAuctionNo"].value;

      // let d= new Date(this.FrmAuctionUpdation.controls['txtAuctionPublishDate'].value);
      // this.model.AuctionPublishDate = d.getFullYear()+'-'+(+d.getMonth()+1)+'-'+d.getDate();

      this.model.AuctionPublishDate = $("#txtAuctionPublishDate1").val();

      this.model.AuctionAuthorityCd =
        this.FrmAuctionUpdation.controls["ddlAuthority"].value;
      this.model.AuctionTypeCd =
        this.FrmAuctionUpdation.controls["ddlAuctionType"].value;
      this.model.AuctionSubTypeCd = 0;
      this.model.AuctionTitle =
        this.FrmAuctionUpdation.controls["txtAuctionTitle"].value;
      this.model.AuctionLocation =
        this.FrmAuctionUpdation.controls["txtLocation"].value;
      this.model.AuctionDetail =
        this.FrmAuctionUpdation.controls["txtDetails"].value;
      this.model.Description = ""; ////this.FrmAuctionUpdation.controls['txtDescription'].value;
      this.model.AuctionAmt =
        this.FrmAuctionUpdation.controls["txtEstimatedAuctionAmt"].value == ""
          ? null
          : this.FrmAuctionUpdation.controls["txtEstimatedAuctionAmt"].value;
      this.model.StartingPrice =
        this.FrmAuctionUpdation.controls["txtStartingPrice"].value;
      this.model.AuctionFee =
        this.FrmAuctionUpdation.controls["txtAuctionFees"].value;
    
      this.model.RegistrationDateFrom = $("#txtRegistrationDateFrom1").val();
      this.model.RegistrationDateTo = $("#txtRegistrationDateTo1").val();
       // Add by Mayank 16012025
       this.model.RegistrationStarttime = this.FrmAuctionUpdation.controls['txtRegistrationTimeFrom'].value;
       this.model.RegistrationEndtime = this.FrmAuctionUpdation.controls['txtRegistrationTimeTo'].value;
       //  End
    
      this.model.EMDAmt =
        this.FrmAuctionUpdation.controls["txtEMDSubmissionAmt"].value;
      this.model.EMDSubimissionStartDate = $("#txtEMDSumissionDateFrom1").val();
      this.model.EMDSubimissionStarttime =
        this.FrmAuctionUpdation.controls["txtEMDSubmissionStartTime"].value;
      this.model.EMDSubimissionEndDate = $("#txtEMDSubmissionDateTo1").val();
      // if (this.model.EMDSubimissionStartDate > this.model.EMDSubimissionEndDate) {
      //   this.MsgService.error("EMD Subimission Start Date cannot more then EMD Subimission end Date  ");
      //   return false;
      // }
      this.model.EMDSubimissionEndtime =
        this.FrmAuctionUpdation.controls["txtEMDSubmissionEndTime"].value;
      this.model.AuctionStartDate = $("#txtAuctionStartDate1").val();
     
      if (this.uploadfilename != "") {
        let base64url_split = this.base64url.split(",")[1];
        //this.model.ImageUrl = base64url_split;
      }
      this.model.AuctionStartTime =
        this.FrmAuctionUpdation.controls["txtAuctionStartTime"].value;
      this.model.AuctionEndDate = $("#txtAuctionEndDate1").val();
      this.model.AuctionEndTime =
        this.FrmAuctionUpdation.controls["txtAuctionEndTime"].value;
      this.model.AuctionPeriod = 0;
      this.model.FinalAuctionEndTime =
        this.FrmAuctionUpdation.controls["txtFinalAuctionEndTime"].value;
      this.model.IncrementalAmt =
        this.FrmAuctionUpdation.controls["txtIncreaseDecreaseAmt"].value;
      this.model.BiddingTypeId =
        this.FrmAuctionUpdation.controls["ddlBiddingType"].value;

      const temp = [];
      for (let i = 0; i < this.AuctionSearchFillPDFList.length; i++) {
        temp.push({
          DocumentName: this.AuctionSearchFillPDFList[i].DocsName,
          DocumentType: "", ////this.AuctionSearchFillPDFList[i].DocType,
          Description: this.AuctionSearchFillPDFList[i].DocsDesc,
          // VirtualPath: this.AuctionSearchFillPDFList[i].VirtualPath,
          // File: this.AuctionSearchFillPDFList[i].File.split(",")[1],
          File:
            this.AuctionSearchFillPDFList[i].status === "Same"
              ? ""
              : this.AuctionSearchFillPDFList[i].File.split(",")[1],
          SrNo: this.AuctionSearchFillPDFList[i].SrNo,
          AutoId: this.AuctionSearchFillPDFList[i].AutoId,
          status: this.AuctionSearchFillPDFList[i].status,
        });
      }
      // console.log(temp);

      this.model.DocumentList = temp;
      // Change 08-07-2020 Participation Docs Checked List
      this.model.ParticipationDocsList = this.CheckedDocsList;
      this.model.WinnerShowInd =
        this.FrmAuctionUpdation.get("ShowWinner").value;
      this.model.AllowedExemptionInd =
        this.FrmAuctionUpdation.get("AllowedExemption").value;

      if (this.FrmAuctionUpdation.get("chkLatLong").value == true) {
        this.model.LatLongInd = 1;
        this.model.Latitude = this.FrmAuctionUpdation.get("txtLatitude").value;
        this.model.Longitude =
          this.FrmAuctionUpdation.get("txtLongitude").value;
      } else {
        this.model.LatLongInd = 0;
        this.model.Latitude = "0";
        this.model.Longitude = "0";
      }
      if (this.FrmAuctionUpdation.get("chkAllowExnt").value == true) {
        this.model.AllowExtInd = 1;
        this.model.Allowautoextension =
          this.FrmAuctionUpdation.get("txtAllext1").value;
        this.model.checkforextension =
          this.FrmAuctionUpdation.get("txtAllext2").value;
        this.model.AutoExtensionTime =
          this.FrmAuctionUpdation.get("txtAllext3").value;
        this.model.AutoExtensionlimit =
          this.FrmAuctionUpdation.get("txtAllext4").value;
      } else {
        this.model.AllowExtInd = 0;
        this.model.Allowautoextension = "";
        this.model.checkforextension = "";
        this.model.AutoExtensionTime = "";
        this.model.AutoExtensionlimit = "";
      }
      this.AuctionEntryService.AuctionUpdation(this.model).subscribe(
        (respdata) => {
          this.AutoIdImage = "0";

          if (respdata != "" && respdata.SuccessCD == 1) {
            this.GridAuctionLive();
            this.MsgService.success(respdata.Msg);
            // this.ImgLoading = false;
            this.ngOnInit();
          }
          if (respdata.RespData[0]["res"] == 0) {
            this.MsgService.warning(respdata.Msg);
            //  this.ImgLoading = false;
          }
        }
      );
      this.Clear();
      // this.ImgLoading = false;
    } catch (err) {}
  }

  fileProgress(event: any) {
    let files = new FileReader();
    let file = event.target.files[0];
    var FileSize = file.size / 1024;

    // let FileExtension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
    // if (FileExtension != 'pdf') {
    //   alert('Please Upload Only Pdf ...!!');
    //   return;
    // }
    // if (file.size > '2097152') {
    //   this.uploadfilename = '';
    //   alert('pdf size can not more than 2 MB');
    //   return false;
    // }
    let FileExtension = file.name.split(".")[1];
    if (FileExtension != "pdf") {
      alert("Please Upload Only Pdf ...!!");
      return;
    }
    if (FileSize > 5000) {
      alert("Max file size allowed is 5 MB. Allowed file type Only pdf.");
      return;
    }

    this.Image = event.target.files[0].value;
    this.uploadfilename = file.name;
    //this.Image =file.path+'/'+file.name;

    files.readAsDataURL(file);
    files.onload = () => {
      this.base64url = files.result;
    };
  }
  isNumberKey(event: { which: any; keyCode: any }) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      if (charCode != 45) return false;
    }
    return true;
  }
  ChkLatitudeLogitudeEvent(evt: { checked: boolean }) {
    if (evt.checked == true) {
      this.FrmAuctionUpdation.controls["txtLongitude"].enable();
      this.FrmAuctionUpdation.controls["txtLatitude"].enable();
    } else {
      this.FrmAuctionUpdation.controls["txtLongitude"].disable();
      this.FrmAuctionUpdation.controls["txtLatitude"].disable();
      this.FrmAuctionUpdation.controls["txtLongitude"].setValue("");
      this.FrmAuctionUpdation.controls["txtLatitude"].setValue("");
    }
  }
  UnpublishedAuctionList: any = [];
  GridAuctionLive() {
    try {
      let Ind = 8;
      let ResponseDecrpt = sessionStorage.getItem("loginSession");
      this.loginlist = JSON.parse(window.atob(ResponseDecrpt));
      let OrgCode = this.loginlist[0]["OrgCode"];
      let CityCode = this.loginlist[0]["CityCode"];

      let UserLevelId = this.loginlist[0]["UserLevelId"];
      let ZoneCode = this.loginlist[0]["ZoneCode"];

      this.AuctionEntryService.GetAuctionGrid(Ind, OrgCode, CityCode).subscribe(
        (resp) => {
          if (resp) {
            if (resp.SuccessCD == 1 && resp.RespData != null) {
              if (UserLevelId == 6) {
                let AuctUpdationList = resp.RespData.Table;
                this.AuctionShowArraysLive = AuctUpdationList.filter(
                  (m: { ZoneCd: any }) => m.ZoneCd == ZoneCode
                );

                this.dataSourceLive = new MatTableDataSource<any>(
                  this.AuctionShowArraysLive
                );
                this.dataSourceLive.paginator = this.paginator.toArray()[0];
                this.dataSourceLive.sort = this.sort.toArray()[0];
              } else {
                this.AuctionShowArraysLive = resp.RespData.Table; //for  published auction

                this.UnpublishedAuctionList = resp.RespData.Table1; // for unpublished auction list

                this.dataSourceLive = new MatTableDataSource<any>(
                  this.AuctionShowArraysLive
                );
                this.dataSourceLive.paginator = this.paginator.toArray()[0];
                this.dataSourceLive.sort = this.sort.toArray()[0];
              }
            } else {
              this.MsgService.warning(resp.MsgDesc);
            }
          } else {
            this.MsgService.error("Server Side Error...");
          }
        },
        (err) => {
          this.MsgService.error(err);
        }
      );
    } catch (error) {
      this.MsgService.error(error);
    }
  }
  applyFilterAuction(filterValue: string) {
    this.dataSourceLive.filter = filterValue.trim().toLowerCase();
  }
  Tender(val: number) {
    if (val == 2) {
      this.dataSourceLive = new MatTableDataSource<any>(
        this.UnpublishedAuctionList
      );
      this.dataSourceLive.paginator = this.paginator.toArray()[0];
      this.dataSourceLive.sort = this.sort.toArray()[0];
    } else {
      this.dataSourceLive = new MatTableDataSource<any>(
        this.AuctionShowArraysLive
      );
      this.dataSourceLive.paginator = this.paginator.toArray()[0];
      this.dataSourceLive.sort = this.sort.toArray()[0];
    }
  }
  UserLevelIdPublishedunPublishedList: boolean = false;
  FillAllDDL() {
    let ResponseDecrpt = sessionStorage.getItem("loginSession");
    this.loginlist = JSON.parse(window.atob(ResponseDecrpt));

    let OrgCode = this.loginlist[0]["OrgCode"];

    let UserLevelId = this.loginlist[0]["UserLevelId"];
    let ZoneCode = this.loginlist[0]["ZoneCode"];

    this.AuctionEntryService.GetAllDDL(OrgCode).subscribe((respdata) => {
      if (respdata != "" && respdata.SuccessCD == 1) {
        if (respdata.RespData.Table.length > 0) {
          // console.log(respdata)
          this.ddlDepartmentList = respdata.RespData.Table;
          this.ddlAuthorityList = respdata.RespData.Table1;
          this.ddlAuctionTypeList = respdata.RespData.Table2;
          this.ddlBiddingTypeList = respdata.RespData.Table3;
          // this.ddlBiddingTypeList = respdata.RespData.Table3
          // this.ddlOfficerList = respdata.RespData.Table4
          if (UserLevelId == 6) {
            this.ddlZoneList = respdata.RespData.Table5;
            this.FrmAuctionUpdation.controls["ddlZone"].disable();
            this.FrmAuctionUpdation.controls["ddlZone"].setValue(ZoneCode);
          } else {
            this.UserLevelIdPublishedunPublishedList = true;
            this.ddlZoneList = respdata.RespData.Table5;
          }
        }
      } else {
        if (respdata != "" && respdata.SuccessCD == 0) {
          this.MsgService.warning(respdata.MsgDesc);
        } else {
          this.MsgService.error("Not Found");
        }
      }
    });
  }

  OnZone_SelectIndex() {
    this.ListDC = null;
    this.ListRO = null;
    this.ListDA = null;
    this.ddlOfficerList = null;

    if (this.FrmAuctionUpdation.controls["ddlZone"].value != "0") {
      let Zonecd = this.FrmAuctionUpdation.controls["ddlZone"].value;
      this.AuctionEntryService.GetFillOfficer(Zonecd).subscribe((respdata) => {
        if (respdata != "" && respdata.SuccessCD == 1) {
          if (respdata.RespData.Table.length > 0) {
            this.ddlOfficerList = respdata.RespData.Table;
            this.ListDA = respdata.RespData.Table1;
            this.ListRO = respdata.RespData.Table2;
            this.ListDC = respdata.RespData.Table3;
          }
        } else {
          if (respdata != "" && respdata.SuccessCD == 0) {
            this.MsgService.warning(respdata.MsgDesc);
          } else {
            this.MsgService.error("Not Found");
          }
        }
      });
    }
  }

  fillAuthority() {
    this.ListDC = null;
    this.ListRO = null;
    this.ListDA = null;
    this.ddlOfficerList = null;

    if (this.AuctionSearchFillList[0]["ZoneCd"] != "0") {
      let Zonecd = this.AuctionSearchFillList[0]["ZoneCd"];
      this.AuctionEntryService.GetFillOfficer(Zonecd).subscribe((respdata) => {
        if (respdata != "" && respdata.SuccessCD == 1) {
          if (respdata.RespData.Table.length > 0) {
            this.ddlOfficerList = respdata.RespData.Table;
            this.ListDA = respdata.RespData.Table1;
            this.ListRO = respdata.RespData.Table2;
            this.ListDC = respdata.RespData.Table3;
          }
        } else {
          if (respdata != "" && respdata.SuccessCD == 0) {
            this.MsgService.warning(respdata.MsgDesc);
          } else {
            this.MsgService.error("Not Found");
          }
        }
      });
    }
  }

  // OnZone_SelectIndex() {

  //   this.ddlOfficerList = null;
  //   if (this.FrmAuctionUpdation.controls['ddlZone'].value != '0') {
  //     let Zonecd = this.FrmAuctionUpdation.controls['ddlZone'].value
  //     this.AuctionEntryService.GetFillOfficer(Zonecd).subscribe(respdata => {

  //       if (respdata != "" && respdata.SuccessCD == 1) {
  //         if (respdata.RespData.Table.length > 0) {
  //           this.ddlOfficerList = respdata.RespData.Table
  //         }
  //       }
  //       else {
  //         if (respdata != "" && respdata.SuccessCD == 0) {
  //           this.MsgService.warning(respdata.MsgDesc);
  //         }
  //         else { this.MsgService.error('Not Found'); }
  //       }
  //     })
  //   }
  // }

  get chkValidSearch() {
    if (
      this.FrmAuctionUpdation.controls["txtAuctionNo"].value == "" ||
      this.FrmAuctionUpdation.controls["txtAuctionNo"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["ddlAuctionType"].value == "" ||
      this.FrmAuctionUpdation.controls["ddlAuctionType"].value == null
    ) {
      return true;
    }
    return false;
  }

  get chkValidUpdate() {
    if (
      this.FrmAuctionUpdation.controls["ddlZone"].value == "" ||
      this.FrmAuctionUpdation.controls["ddlZone"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["ddlOfficer"].value == "" ||
      this.FrmAuctionUpdation.controls["ddlOfficer"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtFinalAuctionEndTime"].value == "" ||
      this.FrmAuctionUpdation.controls["txtFinalAuctionEndTime"].value == null
    ) {
      return true;
    }

    if (
      this.FrmAuctionUpdation.controls["txtEMDSumissionDateFrom"].value == "" ||
      this.FrmAuctionUpdation.controls["txtEMDSumissionDateFrom"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtEMDSubmissionStartTime"].value ==
        "" ||
      this.FrmAuctionUpdation.controls["txtEMDSubmissionStartTime"].value ==
        null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtEMDSubmissionEndTime"].value == "" ||
      this.FrmAuctionUpdation.controls["txtEMDSubmissionEndTime"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtEMDSubmissionDateTo"].value == "" ||
      this.FrmAuctionUpdation.controls["txtEMDSubmissionDateTo"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtAuctionEndDate"].value == "" ||
      this.FrmAuctionUpdation.controls["txtAuctionEndDate"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtAuctionEndTime"].value == "" ||
      this.FrmAuctionUpdation.controls["txtAuctionEndTime"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtAuctionStartDate"].value == "" ||
      this.FrmAuctionUpdation.controls["txtAuctionStartDate"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtAuctionStartTime"].value == "" ||
      this.FrmAuctionUpdation.controls["txtAuctionStartTime"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtEMDSubmissionAmt"].value == "" ||
      this.FrmAuctionUpdation.controls["txtEMDSubmissionAmt"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtStartingPrice"].value == "" ||
      this.FrmAuctionUpdation.controls["txtStartingPrice"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtRegistrationDateTo"].value == "" ||
      this.FrmAuctionUpdation.controls["txtRegistrationDateTo"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtRegistrationDateFrom"].value == "" ||
      this.FrmAuctionUpdation.controls["txtRegistrationDateFrom"].value == null
    ) {
      return true;
    }
    if (this.FrmAuctionUpdation.controls['txtRegistrationTimeFrom'].value == '' || this.FrmAuctionUpdation.controls['txtRegistrationTimeFrom'].value == null|| this.FrmAuctionUpdation.controls['txtRegistrationTimeFrom'].value == '00:00:00') {
      return true;
    }
    if (this.FrmAuctionUpdation.controls['txtRegistrationTimeTo'].value == '' || this.FrmAuctionUpdation.controls['txtRegistrationTimeTo'].value == null|| this.FrmAuctionUpdation.controls['txtRegistrationTimeTo'].value == '00:00:00') {
      return true;
    }
    
    if (
      this.FrmAuctionUpdation.controls["txtAuctionFees"].value == "" ||
      this.FrmAuctionUpdation.controls["txtAuctionFees"].value == null
    ) {
      return true;
    }
    // if (this.FrmAuctionUpdation.controls['txtEstimatedAuctionAmt'].value == '' || this.FrmAuctionUpdation.controls['txtEstimatedAuctionAmt'].value == null) {
    //   return true;
    // }
    if (
      this.FrmAuctionUpdation.controls["txtIncreaseDecreaseAmt"].value == "" ||
      this.FrmAuctionUpdation.controls["txtIncreaseDecreaseAmt"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["ddlBiddingType"].value == "" ||
      this.FrmAuctionUpdation.controls["ddlBiddingType"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["ddlAuthority"].value == "" ||
      this.FrmAuctionUpdation.controls["ddlAuthority"].value == null
    ) {
      return true;
    }
    // // if (this.FrmAuctionUpdation.controls['txtDescription'].value == '' || this.FrmAuctionUpdation.controls['txtDescription'].value == null) {
    // //   return true;
    // // }
    if (
      this.FrmAuctionUpdation.controls["txtDetails"].value == "" ||
      this.FrmAuctionUpdation.controls["txtDetails"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtLocation"].value == "" ||
      this.FrmAuctionUpdation.controls["txtLocation"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtAuctionTitle"].value == "" ||
      this.FrmAuctionUpdation.controls["txtAuctionTitle"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["txtAuctionPublishDate"].value == "" ||
      this.FrmAuctionUpdation.controls["txtAuctionPublishDate"].value == null
    ) {
      return true;
    }
    if (
      this.FrmAuctionUpdation.controls["ddlDepartment"].value == "" ||
      this.FrmAuctionUpdation.controls["ddlDepartment"].value == null
    ) {
      return true;
    }

    if (this.FrmAuctionUpdation.get("Verification").value == 1) {
      if (this.FrmAuctionUpdation.controls["ddlVerifyDA"].invalid == true) {
        return true;
      }
      if (this.FrmAuctionUpdation.controls["ddlVerifyRO"].invalid == true) {
        return true;
      }
      if (this.FrmAuctionUpdation.controls["ddlVerifyDC"].invalid == true) {
        return true;
      }
    }

    if (this.FrmAuctionUpdation.get("chkLatLong").value == true) {
      if (this.FrmAuctionUpdation.controls["txtLatitude"].invalid == true) {
        return true;
      }
      if (this.FrmAuctionUpdation.controls["txtLongitude"].invalid == true) {
        return true;
      }
    }

    return false;
  }
  /***************Change 08-07-2020 **************/

  OnChkParticipationDocs(
    event: { target: { checked: any } },
    DocLst: { DocId: any; DocDesc: any }
  ) {
    if (event.target.checked) {
      this.CheckedDocsList.push({
        DocId: DocLst.DocId,
        DocName: DocLst.DocDesc,
      });
    } else {
      let removeIndex = this.CheckedDocsList.findIndex(
        (item: { DocId: any }) => item.DocId == DocLst.DocId
      );
      this.CheckedDocsList.splice(removeIndex, 1);
    }
    // console.log(this.CheckedDocsList);
  }
  OnSearch(AutionNo: any, AuctionTypecd: any, AuctionId: any) {
    try {
      this.Clear();

      let Ind = 4;
      let ResponseDecrpt = sessionStorage.getItem("loginSession");
      this.loginlist = JSON.parse(window.atob(ResponseDecrpt));

      let OrgCode = this.loginlist[0]["OrgCode"];
      let CityCode = this.loginlist[0]["CityCode"];
      let AuctionNo = AutionNo;
      let AuctionType = AuctionTypecd;
      let AuctId = AuctionId;

      this.AuctionEntryService.OnAuctionSearch(
        Ind,
        OrgCode,
        CityCode,
        AuctionNo,
        AuctionType,
        AuctId
      ).subscribe((respdata) => {
        if (respdata != "" && respdata.SuccessCD == 1) {
          //this.edited = true;
          $("#PannelView").css("display", "block");
          this.editedSearch = false;
          this.VerificationList = [];
          this.AuctionSearchFillList = respdata.RespData.Table;
          this.AuctionSearchFillPDFList = respdata.RespData.Table1;
          if (this.AuctionSearchFillPDFList.length > 0) {
            this.MaxDBSrNo =
              this.AuctionSearchFillPDFList[
                this.AuctionSearchFillPDFList.length - 1
              ]["SrNo"];
          } else {
            this.MaxDBSrNo = 0;
          }

          this.ParticipationDocsList = respdata.RespData.Table2; // for bind

          this.CheckedDocsList = respdata.RespData.Table3; // fro save list

          this.VerificationList = respdata.RespData.Table4;

          this.FrmAuctionUpdation.controls["txtAuctionNo"].setValue(AuctionNo);
          this.FrmAuctionUpdation.controls["ddlAuctionType"].setValue(
            AuctionTypecd
          );

          this.dataSourceDownloadAuction = new MatTableDataSource<any>(
            this.AuctionSearchFillPDFList
          );
          this.dataSourceDownloadAuction.paginator =
            this.paginator.toArray()[1];
          this.dataSourceDownloadAuction.sort = this.sort.toArray()[1];

          this.FillFieldsOnUpdation();
          //  this.ImgLoading = false;
        } else {
          this.MsgService.warning(respdata.Msg);
          // this.ImgLoading = false;
        }
      });
    } catch (err) {
      //  this.ImgLoading = false;
    }
  }

  OnAddUpdate() {
    if (this.btnAddUpdate == "Add") {
      this.DownloadAuctionFalse = false;
      let a = this.AuctionSearchFillPDFList.length - 1;

      this.AuctionSearchFillPDFListNew = [
        {
          DocsName: this.FrmAuctionUpdation.controls["txtDocumentName"].value,
          DocType: "", ////this.FrmAuctionUpdation.controls['txtDocumentType'].value,
          DocsDesc:
            this.FrmAuctionUpdation.controls["txtDocumentDescription"].value,
          File: this.base64url,

          //SrNo: (this.AuctionSearchFillPDFList.length) + 1,
          // SrNo: (this.AuctionSearchFillPDFList[a]['SrNo']) + 1,
          SrNo: this.MaxDBSrNo + 1,
          VirtualPath: this.uploadfilename, // CHANGE
          status: "New",
        },
      ];
      this.MaxDBSrNo = this.MaxDBSrNo + 1;
      if (Number(this.id !== 0)) {
        this.AuctionSearchFillPDFList.splice(Number(this.id), 1);
      }

      this.AuctionSearchFillPDFListNew.forEach((i: any) => {
        this.AuctionSearchFillPDFList.push(i);
      });

      this.dataSourceDownloadAuction = new MatTableDataSource<any>(
        this.AuctionSearchFillPDFList
      );
      this.dataSourceDownloadAuction.paginator = this.paginator.toArray[0];
      this.dataSourceDownloadAuction.sort = this.sort.toArray[0];

      this.uploadfilename = "";
      this.vt = this.uploadfilename;
      this.FrmAuctionUpdation.controls["txtDocumentName"].setValue("");
      ////this.FrmAuctionUpdation.controls['txtDocumentType'].setValue('');
      this.FrmAuctionUpdation.controls["txtDocumentDescription"].setValue("");
      this.FrmAuctionUpdation.controls["file"].setValue("");
    }
    if (this.btnAddUpdate == "Update") {
      let path = "";
      if (this.uploadfilename === "") {
        path = this.AuctionSearchFillPDFList[Number(this.id)]["VirtualPath"];
      } else {
        path = this.uploadfilename;
      }

      this.AuctionSearchFillPDFListNew = [
        {
          DocsName: this.FrmAuctionUpdation.controls["txtDocumentName"].value,
          DocType: "", ////this.FrmAuctionUpdation.controls['txtDocumentType'].value,
          DocsDesc:
            this.FrmAuctionUpdation.controls["txtDocumentDescription"].value,
          SrNo: this.AuctionSearchFillPDFList[Number(this.id)]["SrNo"],
          AuctionId:
            this.AuctionSearchFillPDFList[Number(this.id)]["AuctionId"],
          AutoId: this.AuctionSearchFillPDFList[Number(this.id)]["AutoId"],
          VirtualPath: path,
          File: this.uploadfilename === "" ? "" : this.base64url,
          status: this.uploadfilename === "" ? "Update" : "FullUpdate",
        },
      ];

      this.AuctionSearchFillPDFList.splice(Number(this.id), 1);
      this.AuctionSearchFillPDFListNew.forEach((i: any) => {
        this.AuctionSearchFillPDFList.push(i);
      });

      this.dataSourceDownloadAuction = new MatTableDataSource<any>(
        this.AuctionSearchFillPDFList
      );
      this.dataSourceDownloadAuction.paginator = this.paginator.toArray[0];
      this.dataSourceDownloadAuction.sort = this.sort.toArray[0];

      this.uploadfilename = "";
      this.btnAddUpdate = "Add";
      this.FrmAuctionUpdation.controls["txtDocumentName"].setValue("");
      //// this.FrmAuctionUpdation.controls['txtDocumentType'].setValue('');
      this.FrmAuctionUpdation.controls["txtDocumentDescription"].setValue("");
      this.FrmAuctionUpdation.controls["file"].setValue("");
    }
  }
  OnEdit(I: number, DocumentName: string, DocDesc: string) {
    this.btnAddUpdate = "Update";
    this.uploadfilename = "";
    this.id = I;
    this.FrmAuctionUpdation.controls["txtDocumentName"].setValue(DocumentName);
    ////this.FrmAuctionUpdation.controls['txtDocumentType'].setValue(DocumentType);
    this.FrmAuctionUpdation.controls["txtDocumentDescription"].setValue(
      DocDesc
    );
  }
  OnRemove(id: number) {
    var ok = confirm("Are You sure you want to delete this record");
    if (ok) {
      this.AuctionSearchFillPDFList.splice(id, 1);
      this.dataSourceDownloadAuction = null;
      this.dataSourceDownloadAuction = new MatTableDataSource<any>(
        this.AuctionSearchFillPDFList
      );
      this.dataSourceDownloadAuction.paginator = this.paginator.toArray[0];
      this.dataSourceDownloadAuction.sort = this.sort.toArray[0];
    } else {
      alert("Cancel");
    }
  }
  FillFieldsOnUpdation() { 
    
    this.FrmAuctionUpdation.controls['txtRegistrationTimeFrom'].setValue(this.AuctionSearchFillList[0]['ParticipationStartTime']);
    this.FrmAuctionUpdation.controls['txtRegistrationTimeTo'].setValue(this.AuctionSearchFillList[0]['ParticipationEndTime']);
    
    this.AuctionId = this.AuctionSearchFillList[0]["AuctionTitle"];
    this.FrmAuctionUpdation.controls["txtAuctionTitle"].setValue(
      this.AuctionSearchFillList[0]["AuctionTitle"]
    );
    this.FrmAuctionUpdation.controls["ddlDepartment"].setValue(
      this.AuctionSearchFillList[0]["DeptCd"]
    );
    this.FrmAuctionUpdation.controls["ddlZone"].setValue(
      this.AuctionSearchFillList[0]["ZoneCd"]
    );

    this.FrmAuctionUpdation.controls["ddlOfficer"].setValue(
      this.AuctionSearchFillList[0]["Officecd"]
    );
    this.FrmAuctionUpdation.controls["txtAuctionPublishDate"].setValue(
      this.AuctionSearchFillList[0]["AuctionPublishDate"]
    );
    this.FrmAuctionUpdation.controls["ddlAuthority"].setValue(
      this.AuctionSearchFillList[0]["AuctionAuthorityCd"]
    );
    this.FrmAuctionUpdation.controls["txtLocation"].setValue(
      this.AuctionSearchFillList[0]["AuctionLocation"]
    );
    this.FrmAuctionUpdation.controls["txtDetails"].setValue(
      this.AuctionSearchFillList[0]["AuctionDetail"]
    );
    //// this.FrmAuctionUpdation.controls['txtDescription'].setValue(this.AuctionSearchFillList[0]['Description']);
    this.FrmAuctionUpdation.controls["txtEstimatedAuctionAmt"].setValue(
      this.AuctionSearchFillList[0]["AuctionAmt"]
    );
    this.FrmAuctionUpdation.controls["txtStartingPrice"].setValue(
      this.AuctionSearchFillList[0]["StartingPrice"]
    );
    this.FrmAuctionUpdation.controls["txtAuctionFees"].setValue(
      this.AuctionSearchFillList[0]["AuctionFee"]
    );
    this.FrmAuctionUpdation.controls["txtRegistrationDateFrom"].setValue(
      this.AuctionSearchFillList[0]["RegistrationDateFrom"]
    );
    this.FrmAuctionUpdation.controls["txtRegistrationDateTo"].setValue(
      this.AuctionSearchFillList[0]["RegistrationDateTo"]
    );
    this.FrmAuctionUpdation.controls["txtEMDSubmissionAmt"].setValue(
      this.AuctionSearchFillList[0]["EMDAmt"]
    );
    this.FrmAuctionUpdation.controls["txtEMDSumissionDateFrom"].setValue(
      this.AuctionSearchFillList[0]["EMDSubimissionStartDate"]
    );
    this.FrmAuctionUpdation.controls["txtEMDSubmissionStartTime"].setValue(
      this.AuctionSearchFillList[0]["EMDSubimissionStarttime"]
    );
    this.FrmAuctionUpdation.controls["txtEMDSubmissionDateTo"].setValue(
      this.AuctionSearchFillList[0]["EMDSubimissionEndDate"]
    );
    this.FrmAuctionUpdation.controls["txtEMDSubmissionEndTime"].setValue(
      this.AuctionSearchFillList[0]["EMDSubimissionEndtime"]
    );
    this.FrmAuctionUpdation.controls["txtAuctionStartDate"].setValue(
      this.AuctionSearchFillList[0]["AuctionStartDate"]
    );
    this.FrmAuctionUpdation.controls["txtAuctionStartTime"].setValue(
      this.AuctionSearchFillList[0]["AuctionStartTime"]
    );
    this.FrmAuctionUpdation.controls["txtAuctionEndDate"].setValue(
      this.AuctionSearchFillList[0]["AuctionEndDate"]
    );
    this.FrmAuctionUpdation.controls["txtAuctionEndTime"].setValue(
      this.AuctionSearchFillList[0]["AuctionEndTime"]
    );
    this.FrmAuctionUpdation.controls["txtFinalAuctionEndTime"].setValue(
      this.AuctionSearchFillList[0]["FinalAuctionEndTime"]
    );
    this.FrmAuctionUpdation.controls["txtIncreaseDecreaseAmt"].setValue(
      this.AuctionSearchFillList[0]["IncrementalAmt"]
    );
    this.FrmAuctionUpdation.controls["ddlBiddingType"].setValue(
      this.AuctionSearchFillList[0]["BiddingTypeId"]
    );

    this.FrmAuctionUpdation.controls["txtLatitude"].setValue(
      this.AuctionSearchFillList[0]["Latitude"]
    );
    this.FrmAuctionUpdation.controls["txtLongitude"].setValue(
      this.AuctionSearchFillList[0]["Longitude"]
    );

    if (this.AuctionSearchFillList[0]["LatLongInd"] == 1) {
      this.FrmAuctionUpdation.controls["chkLatLong"].setValue("1");
    } else {
      this.FrmAuctionUpdation.controls["chkLatLong"].setValue("0");
    }
    if (this.AuctionSearchFillList[0]["AllowExtInd"] == 1) {
      this.ChkExtChecked = true;
      // this.FrmAuctionUpdation.controls["chkAllowExnt"].setValue("1");
      this.FrmAuctionUpdation.controls["txtAllext1"].enable();
      this.FrmAuctionUpdation.controls["txtAllext2"].enable();
      this.FrmAuctionUpdation.controls["txtAllext3"].enable();
      this.FrmAuctionUpdation.controls["txtAllext4"].enable();
    } else {
      this.ChkExtChecked = false;
      // this.FrmAuctionUpdation.controls["chkAllowExnt"].setValue("0");
      this.FrmAuctionUpdation.controls["txtAllext1"].disable();
      this.FrmAuctionUpdation.controls["txtAllext2"].disable();
      this.FrmAuctionUpdation.controls["txtAllext3"].disable();
      this.FrmAuctionUpdation.controls["txtAllext4"].disable();
    }
    this.FrmAuctionUpdation.controls["txtAllext1"].setValue(
      this.AuctionSearchFillList[0]["Allowautoextension"]
    );
    this.FrmAuctionUpdation.controls["txtAllext2"].setValue(
      this.AuctionSearchFillList[0]["checkforextension"]
    );
    this.FrmAuctionUpdation.controls["txtAllext3"].setValue(
      this.AuctionSearchFillList[0]["AutoExtensionTime"]
    );
    this.FrmAuctionUpdation.controls["txtAllext4"].setValue(
      this.AuctionSearchFillList[0]["AutoExtensionlimit"]
    );
    this.fillAuthority();

    if (this.VerificationList.length > 0) {
      this.verifyselectedDA = this.VerificationList.filter(
        (m: { Levelid: number }) => m.Levelid == 6
      );
      this.verifyselectedRO = this.VerificationList.filter(
        (m: { Levelid: number }) => m.Levelid == 7
      );
      this.verifyselectedDC = this.VerificationList.filter(
        (m: { Levelid: number }) => m.Levelid == 8
      );
      if (this.verifyselectedDA.length > 0) {
        this.FrmAuctionUpdation.controls["ddlVerifyDA"].setValue(
          this.verifyselectedDA[0]["UserId"]
        );
      }
      if (this.verifyselectedRO.length > 0) {
        this.FrmAuctionUpdation.controls["ddlVerifyRO"].setValue(
          this.verifyselectedRO[0]["UserId"]
        );
      }

      if (this.verifyselectedDC.length > 0) {
        this.FrmAuctionUpdation.controls["ddlVerifyDC"].setValue(
          this.verifyselectedDC[0]["UserId"]
        );
      }
    } else {
      this.FrmAuctionUpdation.controls["ddlVerifyDA"].setValue("");
      this.FrmAuctionUpdation.controls["ddlVerifyRO"].setValue("");
      this.FrmAuctionUpdation.controls["ddlVerifyDC"].setValue("");
    }

    let d = this.AuctionSearchFillList[0]["ParticipationVerifyInd"];
    //this.FrmAuctionUpdation.controls['Verification'].setValue(d);
    if (d == 1) {
      this.myBool = true;
      //this.Verification.patchValue({value:'1', Verification:true});
      $("#chkYe").prop("checked", true);
      $("#chkNo").prop("checked", false);
      this.RadioChange(1);
    } else {
      this.myBool = false;
      $("#chkYe").prop("checked", false);
      $("#chkNo").prop("checked", true);
      this.RadioChange(2);

      //Verification: ['2', Validators.required];
      //this.FrmAuctionUpdation.controls['Verification'].setValue(this.myBool);
    }

    let WinShow = this.AuctionSearchFillList[0]["WinnerShowInd"];
    let ExcemptionInd = this.AuctionSearchFillList[0]["EmdExemptionInd"];

    //this.FrmAuctionUpdation.controls['Verification'].setValue(d);
    if (WinShow == 1) {
      //this.myBool = true;
      this.FrmAuctionUpdation.controls["ShowWinner"].setValue("1");
    }
    if (ExcemptionInd == 1) {
      // this.myBool = true;
      this.FrmAuctionUpdation.controls["AllowedExemption"].setValue("1");
    }
  }
  get AddDisable() {
    if (
      this.FrmAuctionUpdation.controls["txtDocumentName"].value == "" ||
      this.FrmAuctionUpdation.controls["txtDocumentName"].value == null
    ) {
      return true;
    }
    // // if (this.FrmAuctionUpdation.controls['txtDocumentType'].value == '' || this.FrmAuctionUpdation.controls['txtDocumentType'].value == null) {
    // //   return true;
    // // }
    if (
      this.FrmAuctionUpdation.controls["txtDocumentDescription"].value == "" ||
      this.FrmAuctionUpdation.controls["txtDocumentDescription"].value == null
    ) {
      return true;
    }

    if (this.btnAddUpdate === "Add") {
      if (this.uploadfilename === "") {
        return true;
      }
    }
    return false;
  }

  chkAllowExtension(evt: any) {    
    if (evt.checked == true) {
      this.ChkExtChecked = true;
      this.FrmAuctionUpdation.controls["txtAllext1"].enable();
      this.FrmAuctionUpdation.controls["txtAllext2"].enable();
      this.FrmAuctionUpdation.controls["txtAllext3"].enable();
      this.FrmAuctionUpdation.controls["txtAllext4"].enable();
    } else {
      this.ChkExtChecked = false;
      this.FrmAuctionUpdation.controls["txtAllext1"].disable();
      this.FrmAuctionUpdation.controls["txtAllext2"].disable();
      this.FrmAuctionUpdation.controls["txtAllext3"].disable();
      this.FrmAuctionUpdation.controls["txtAllext4"].disable();

      this.FrmAuctionUpdation.controls["txtAllext1"].setValue("");
      this.FrmAuctionUpdation.controls["txtAllext2"].setValue("");
      this.FrmAuctionUpdation.controls["txtAllext3"].setValue("");
      this.FrmAuctionUpdation.controls["txtAllext4"].setValue("");
    }
  }

  /********************************* Start Date Compare Validation *******************/
  OnRegistrationDateFrom() {
    var AuctionPublishedDate = $("#txtAuctionPublishDate1").val();
    let RegDateFrom = $("#txtRegistrationDateFrom1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(
      AuctionPublishedDate,
      RegDateFrom
    );
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionUpdation.get("txtRegistrationDateFrom").reset("");
      this.MsgService.warning(
        "Participation Start Date Can Not Be Less then Auction Published Date..!!"
      );
      return;
    }
  }
  OnRegistrationDateTo() {
    let RegDateFrom = $("#txtRegistrationDateFrom1").val();
    let RegDateTo = $("#txtRegistrationDateTo1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(RegDateFrom, RegDateTo);
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionUpdation.get("txtRegistrationDateTo").reset("");
      this.MsgService.warning(
        "Participation End Date Can Not Be Less then Participation Start Date..!!"
      );
      return;
    }
  }
  OnEMDDateFrom() {
    let RegDateFrom = $("#txtRegistrationDateFrom1").val();

    let EMDDateFrom = $("#txtEMDSumissionDateFrom1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(RegDateFrom, EMDDateFrom);
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionUpdation.get("txtEMDSumissionDateFrom").reset("");
      this.MsgService.warning(
        "EMD Submission Start Date Can Not Be Less then Participation Start Date..!!"
      );
      return;
    }
  }
  OnEMDDateTo() {
    let EMDDateFrom = $("#txtEMDSumissionDateFrom1").val();
    let EMDDateTo = $("#txtEMDSubmissionDateTo1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(EMDDateFrom, EMDDateTo);
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionUpdation.get("txtEMDSubmissionDateTo").reset("");
      this.MsgService.warning(
        "EMD Submission End Date Can Not Be Less then EMD Submission Start Date..!!"
      );
      return;
    }
  }
  OnAuctionStartDate() {
    let EMDDateTo = $("#txtEMDSubmissionDateTo1").val();
    let AuctionStartDate = $("#txtAuctionStartDate1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(
      EMDDateTo,
      AuctionStartDate
    );
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionUpdation.get("txtAuctionStartDate").reset("");
      this.MsgService.warning(
        "Auction Start Date Can Not Be Less then EMD Submission End Date..!!"
      );
      return;
    }
  }
  OnAuctionEndDate() {
    let AuctionStartDate = $("#txtAuctionStartDate1").val();
    let AuctionEndDate = $("#txtAuctionEndDate1").val();
    this.checkAppDate = this.CompareSrvc.DateCompare(
      AuctionStartDate,
      AuctionEndDate
    );
    // if approval date greater then  application date then return false  else true .
    // Date Must Be required formate is dd-MM-yyyy
    if (this.checkAppDate === true) {
      this.FrmAuctionUpdation.get("txtAuctionEndDate").reset("");
      this.MsgService.warning(
        "Auction End Date Can Not Be Less then Auction Start Date..!!"
      );
      return;
    }
  }
  /*************************************** END Date Compare Validation *****************************************/
}
